module.exports = __webpack_public_path__ + "static/media/cred-card.272b5e2c.svg";